import watch   from "redux-watch";
import isEqual from 'is-equal';
import ControllerBase   from './controller_base';
export default class ResponseController extends ControllerBase{
  constructor(tag) {
    super(tag);
    this.listenResponseThen();
  }

  listenResponseThen(){
    this.reduxEvent('data.response_then', (newVal, oldVal, objectPath) => {
      this.onResponse(newVal, oldVal, objectPath);
    });
  }
  // サーバーからのレスポンス
  onResponse(newVal, oldVal, projectPath){
    if(newVal == null){ return; }
    if(newVal.method == 'on_create_comment') {
      this.onCreateComment(newVal.options);
    } else if (newVal.method == 'on_destroy_comment') {
      this.onDestroyComment(newVal.options);
    }
  }
  // コメントが追加された
  onCreateComment(options){
    this.clearAndNewValue(options);
    this.dispatchNewValue({response_then: null})
  }
  // コメントが削除された
  onDestroyComment(options){
    this.clearAndNewValue(options);
    this.dispatchNewValue({response_then: null})
  }
  clearAndNewValue(options){
    let clear = options.clear
    let newVal = options.newVal;
    this.dispatchNewValue(clear);
    this.dispatchNewValue(newVal);
  }
}
